function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { Space, Button, Skeleton, message, Drawer, Dropdown, Modal, notification } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { UmbrellaFill, Building, PencilSquare, XSquareFill, MegaphoneFill, EnvelopeCheckFill } from 'react-bootstrap-icons';
import NewCompany from "../components/forms/NewCompany";
import NewInsurance from "../components/forms/NewInsurance";
import Common from "../components/includes/Common";
import EditCompany from "../components/forms/EditCompany";
import SendBroadcastSms from "../components/forms/SendBroadcastSms";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Companies = function Companies() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    newCompanyVisible = _useState2[0],
    setNewCompanyVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    newInsuranceVisible = _useState4[0],
    setNewInsuranceVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    reportsDrawerVisible = _useState6[0],
    setReportsDrawerVisible = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    icList = _useState8[0],
    setIcList = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isDataLoading = _useState0[0],
    setIsDataLoading = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedCompany = _useState10[0],
    setSelectedCompany = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showEdit = _useState12[0],
    setShowEdit = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    dataChanged = _useState14[0],
    setDataChanged = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showSendBroadcast = _useState16[0],
    setShowSenBroadcast = _useState16[1];
  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.get(Common.baseApiUrl + 'getcompanylist').then(function (response) {
      if (response.data.status == 200) {
        setIcList(response.data.companyList);
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsx(Space, {
            direction: "horizontal",
            children: /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: function onClick() {
                setNewCompanyVisible(true);
              },
              icon: /*#__PURE__*/_jsx(Building, {}),
              children: /*#__PURE__*/_jsx("b", {
                children: "AJOUTER UNE SOCIETE"
              })
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
            className: "cool-radius white-bg",
            children: [/*#__PURE__*/_jsxs(Table, {
              responsive: true,
              bordered: true,
              stripped: true,
              children: [/*#__PURE__*/_jsx("thead", {
                children: /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("th", {
                    children: "Nom complet"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Nom court"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "E-mail"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Tel"
                  }), /*#__PURE__*/_jsx("th", {})]
                })
              }), /*#__PURE__*/_jsx("tbody", {
                children: icList.map(function (ic) {
                  return /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: ic.label
                    }), /*#__PURE__*/_jsx("td", {
                      children: ic.short_name
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Dropdown, {
                        menu: {
                          items: [{
                            label: /*#__PURE__*/_jsx("span", {
                              children: "RH : " + ic.email
                            }),
                            key: "m1"
                          }, {
                            label: /*#__PURE__*/_jsx("span", {
                              children: "Facturation :" + ic.email_1
                            }),
                            key: "m2"
                          }, {
                            label: /*#__PURE__*/_jsx("span", {
                              children: "Commercial :" + ic.email_2
                            }),
                            key: "m3"
                          }]
                        },
                        children: /*#__PURE__*/_jsx("a", {
                          onClick: function onClick(e) {
                            return e.preventDefault();
                          },
                          children: /*#__PURE__*/_jsxs(Space, {
                            children: ["Afficher ", /*#__PURE__*/_jsx(DownOutlined, {})]
                          })
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: ic.telephone
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsxs(Space, {
                        direction: "horizontal",
                        children: [/*#__PURE__*/_jsx(Button, {
                          type: "default",
                          onClick: function onClick() {
                            setSelectedCompany(ic);
                            setShowEdit(true);
                          },
                          children: /*#__PURE__*/_jsx("b", {
                            children: /*#__PURE__*/_jsx(PencilSquare, {
                              size: 20
                            })
                          })
                        }), /*#__PURE__*/_jsx(Button, {
                          type: "link",
                          onClick: function onClick() {
                            setSelectedCompany(ic);
                            setShowSenBroadcast(true);
                          },
                          children: /*#__PURE__*/_jsx(MegaphoneFill, {
                            size: 20
                          })
                        })]
                      })
                    })]
                  }, ic.id);
                })
              })]
            }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: newCompanyVisible,
      width: 370,
      destroyOnClose: true,
      title: "Ajouter une entreprise",
      onClose: function onClose() {
        setNewCompanyVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(NewCompany, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    }), selectedCompany && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        open: showEdit,
        width: 370,
        destroyOnClose: true,
        title: "Ajouter une entreprise",
        onClose: function onClose() {
          setShowEdit(false);
        },
        closable: true,
        children: /*#__PURE__*/_jsx(EditCompany, {
          company: selectedCompany,
          handler: function handler() {
            setDataChanged(true);
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        open: showSendBroadcast,
        width: {
          xs: '90%',
          sm: '80%',
          md: '40%',
          lg: '40%',
          xl: '30%',
          xxl: '30%'
        },
        footer: null,
        destroyOnClose: true,
        title: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(EnvelopeCheckFill, {
            size: 28
          }), " ", "Envoi un Bulk SMS à " + selectedCompany.label]
        }),
        onCancel: function onCancel() {
          setShowSenBroadcast(false);
        },
        closable: true,
        children: /*#__PURE__*/_jsx(SendBroadcastSms, {
          company: selectedCompany,
          handler: function handler() {
            notification.success({
              message: "Ok!",
              description: "Opération Lancée !"
            });
            setShowSenBroadcast(false);
          }
        })
      })]
    })]
  });
};
export default Companies;